import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MealSetInclude } from '@interface/mealsetincludes.interface';
import { MealSetService } from '@service/api/mealset.service';
import { MealSet } from '@interface/mealset.interface';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

export interface MenuItem {
  name: string;
  tagline: string;
  description: string;
  price: number;
  allergies: string[];
}
export interface Price {
  price: number;
  rule: string;
}
export interface Image {
  jpg: string;
  webp: string;
}

@Component({
  selector: 'app-mealset',
  templateUrl: './mealset.component.html',
  styleUrls: ['./mealset.component.scss']
})
export class MealsetComponent implements OnInit {

  constructor(
    public api: MealSetService
  ) {}

  @Input() id: string|number = '';
  @Input() title: string = '';
  @Input() tagline: string  = '';
  @Input() image: Image = {
    jpg: '',
    webp: '',
  };
  @Input() open:boolean = false;
  @Input() published: boolean = false;

  description: string  = '';
  includes: MealSetInclude[] = [];
  price?: Price;

  mealSet$:Observable<MealSet> = new Observable<MealSet>();

  ngOnInit() {
    this.mealSet$ = this.api.get(String(this.id));
  }

  expand():void {
    if(this.open)
      this.open = false;
    else
      this.open = true;
  }
}
